import Image from 'next/legacy/image';
import { useState } from 'react';
import { BodyRegular, H1, H2, H3, H4 } from '@components/atoms/typography';
import AnimateSpinner from '@components/animate-spinner';

const MiniLeagueAward = ({
  managerName,
  awardName,
  awardExplainer,
  teamName,
  currentGameweek
}: {
  managerName: string;
  awardName: string;
  awardExplainer: string;
  teamName: string;
  currentGameweek: number | string | null;
}) => {
  const [hasLoaded, setHasLoaded] = useState(false);

  return (
    <div>
      {!hasLoaded && <AnimateSpinner />}
      <div className="relative w-full h-[575px]">
        <Image
          src={`/images/awards/shields-with-images/${awardName}.png`}
          alt="Fantasy Football Hub Shield background"
          layout="fill"
          objectFit="contain"
          onLoadingComplete={() => {
            setHasLoaded(true);
          }}
        />
        {hasLoaded && (
          <>
            <div className="absolute flex flex-col items-center justify-center top-[100px] w-full z-50">
              <H2 textColor="text-white" className="whitespace-nowrap">
                {awardName}
              </H2>
              <BodyRegular textColor="text-white whitespace-nowrap">
                {awardExplainer}
              </BodyRegular>
            </div>
            <div className="absolute bottom-[70px] w-full z-50">
              <div className="flex flex-col justify-between items-center">
                <H1 textColor="text-white" className="whitespace-nowrap">
                  {managerName}
                </H1>
                <H4 textColor="text-white" className="whitespace-nowrap">
                  {teamName}
                </H4>
                <H3 textColor="text-white" className="whitespace-nowrap">
                  GW{currentGameweek}
                </H3>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default MiniLeagueAward;
